import "~/misc/common";
import DeviceBase from "./device_base";

export default class extends DeviceBase {
  connect() {
    this.connectBase({
      channel: "DeviceIfChannel",
      onEvent: (msg: string) => {
        $('#state_event').val($('#state_event').val() + msg + '\n');
        $('#state_event').scrollTop($('#state_event')[0].scrollHeight - $('#state_event').height()!);
      }
    });


    $('form.state').on('submit', (e) => {
      e.preventDefault();
      const command = $('#state_command').val();
      if (typeof command === 'string' && command.length > 0) {
        this.sendCmd(command);
      }
    });

    $('#clearEvents').on('click', function () {
      $('#state_event').val('');
    });
  }
}
